import React from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../authentications/SessionContext";
import { posLink } from "../../DataApi/pointOfSaleLink";
import SidebarListOption from "./SidebarListOption";

const SidebarComponent = ({ optionsList = [], nestingLevel }) => {
  const { showSidebar } = useSession();
  const navigate = useNavigate();
  let myPoSLink = null;
  let origin = window.location.origin;
  // console.log("origin", origin);

  const handleClick = async (menuItem) => {
    if (menuItem.link) return navigate(menuItem.link);
    try {
      let response = await posLink("point_of_sale.menu_point_root");
      response = JSON.parse(response);
      if (response?.result) {
        // myPoSLink = "http://127.0.0.1:8069" + response?.result?.url;
        myPoSLink = origin + response?.result?.url;
        // console.log("response of pos link api", response, myPoSLink);

        // Open the link in a new tab
        window.open(myPoSLink, "_blank").focus();
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  // console.log("sidebarlist", SIDEBAR_OPTIONS_LIST);
  // const handlePoSClick = (e) => {
  //   // console.log("e", e);
  //   e.target.classList.remove("active");
  //   getPoSLink("point_of_sale.menu_point_root");
  // };
  // console.log("sideBarOption", optionsList);
  return (
    <>
      {optionsList
        .filter((sideBarOption) => sideBarOption.showSideBar)
        .map((sideBarOption, index) => (
          <SidebarListOption
            key={`${sideBarOption.name}-${index}`}
            sideBarOption={sideBarOption}
            index={index}
            handleClick={handleClick}
            showSidebar={showSidebar}
            nestingLevel={nestingLevel}
          />
        ))}
    </>
  );
};

export default SidebarComponent;
